import { useEffect, useRef, useState } from 'react'

export const useStateRef = <T>(initialValue) => {
  const [value, setValue] = useState<T>(initialValue)

  const valueRef = useRef(value)

  useEffect(() => {
    valueRef.current = value
  }, [value])

  return { value, setValue, valueRef }
}
